import React from "react";
import Skeleton from "react-loading-skeleton";

const ListingSkeleton = () => {
    return (
        <div className="col-md-12 as-col-table-container">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Property Name</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Location</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Type</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Amount requested</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Statut</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Statut Publication</th>
                        <th scope="col" style={{ color: '#A0AEC0' }} className="th-table-admin">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                    <tr>
                        <th scope="row"><Skeleton /></th>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                        <td><Skeleton /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ListingSkeleton;